module.exports = {
	torayWebDomain : "www.contact.toray"
}
